import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { EtatService } from '../../Services/etat';

type Groupe = {
  tag: string;
  installations: { id: number; nom: string }[];
  ouvert: ReturnType<typeof signal<boolean>>;
};

const CATEGORIES: { label: string; tag: string }[] = [
  { label: 'Vente Totale', tag: 'Vente Totale' },
  { label: 'Autoconso', tag: 'AC injection surplus' },
  { label: 'Ordres Agrégateur', tag: 'Ordres Agrégateur' },
  { label: 'Ordres DEIE', tag: 'Ordres DEIE' },
  { label: 'Trackers', tag: 'Trackers' },
  { label: 'Batterie', tag: 'Batterie' },
];

@Component({
  selector: 'app-parc-installations-par-types',
  imports: [CommonModule, RouterLink],
  templateUrl: './parc-installations-par-types.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './parc-installations-par-types.css',
})
export class ParcInstallationsParTypesComponent {
  private etat = inject(EtatService);

  groupes = computed<Groupe[]>(() => {
    const liste = this.etat.installations();
    const map = new Map<string, { id: number; nom: string }[]>(
      CATEGORIES.map((c) => [c.label, []]),
    );
    for (const installation of liste) {
      const tags = installation.tags as unknown as string[];
      for (const tag of tags ?? []) {
        const categorie = CATEGORIES.find((c) => c.tag.toLowerCase() === tag.toLowerCase());
        if (categorie) map.get(categorie.label)!.push(installation);
      }
    }
    return [...map.entries()]
      .filter(([, installations]) => installations.length > 0)
      .sort(([, a], [, b]) => b.length - a.length)
      .map(([tag, installations]) => ({
        tag,
        installations: installations.sort((a, b) => a.nom.localeCompare(b.nom, 'fr')),
        ouvert: signal(false),
      }));
  });
}
